import * as _ from 'lodash';
import { IRowData } from './row-data';

/**
 * The default order for both pre-select grids, in three keys:
 *
 *   1. decision status  - awaiting a decision first, then accepted, then declined
 *   2. eplet mismatch   - singleEpletMmRisk.sortValue ascending, so lower risk first
 *   3. donor alias      - ascending, as the final tie-breaker
 *
 * Defined once here because the two pages render the same grid. The status order used to live
 * inline in the recipient page's getFilteredData, so the required pre-selects page - which renders
 * that grid per recipient - showed its donors in whatever order the API returned them.
 *
 * The alias key makes the result fully deterministic. Neither pre-select statement carries an
 * ORDER BY, and their plans run parallel, so the order rows arrive in is not reproducible between
 * loads; sorting to a unique column here fixes that on the client without paying for a sort in the
 * database. Donor aliases are unique, non-blank and uppercase across the live pool, so a plain
 * ascending string compare is enough - no case folding needed.
 */
export const acceptedRank = (row: IRowData) => {
    const { isAccepted } = row.donor;

    if (isAccepted == null) {
        return 0;
    }

    return isAccepted == true ? 1 : 2;
};

/**
 * SortValue is a computed band on the entity - 0 for zero risk, rising through the risk tiers,
 * 9999 for no data and 99999 for ABO-incompatible - so ascending puts the lowest risk first and
 * pushes unknown and incompatible to the bottom.
 */
export const epletMmRank = (row: IRowData) => row.singleEpletMmRisk.sortValue;

export const aliasRank = (row: IRowData) => row.donor.alias;

export const orderByPreSelectDefault = (rows: IRowData[]) =>
    _.orderBy(rows, [acceptedRank, epletMmRank, aliasRank], ['asc', 'asc', 'asc']);
